export class MultiStepForm {

    requiredFields = 'input[aria-required="true"], textarea[aria-required="true"], .wpcf7-validates-as-required input'
    constructor(formSelector) {
        this.form = document.querySelector(formSelector);

        if (!this.form) {
            console.error('Form must be provided');
            return;
        }

        this.steps = this.form.querySelectorAll('.step');
        this.stepItems = this.form.querySelectorAll('.form-option-interest');
        this.nextBtn = this.form.querySelector('#next-btn');
        // this.prevBtn = this.form.querySelector('#prev-btn');
        this.submitBtn = this.form.querySelector('[type="submit"]');
        this.submitWrapper = this.form.querySelector('.submit-wrapper');
        this.currentStepEl = this.form.querySelector('.current-step');
        this.lastStepEl = this.form.querySelector('.last-step');
        this.mailIconEl = this.form.querySelector('.mail-icon');
        this.formrender = this.form.querySelector('.col-wrapper.form-render');
        this.successRender = this.form.querySelector('.col-wrapper.success');
        this.requiredField = this.form.querySelector('.col-wrapper.success');
        // this.stepListDescr = this.form.querySelector('.step-list-description');
        // this.successText = this.form.querySelector('.col-wrapper > .success-text');
        this.currentStep = 0;

        this.selectInterestForm = document.querySelector('#change-form-interest');
        this.selectContactForm = document.querySelector('#change-form-contact');

        this.init();
    }

    init() {
        if (!this.steps.length) {
            console.error('Steps must be provided');
            return;
        }

        if(this.lastStepEl) {
            this.lastStepEl.textContent = this.steps.length;
        }

        this.showStep(this.currentStep);
        this.addEventListeners();
        // this.updateNextButtonState();
        this.afterSending();
        // this.generateArithmeticProblem();
    }

    showStep(index) {
        this.steps.forEach((step, i) => {
            step.classList.toggle('show', i === index);
        });

        if(this.currentStepEl) {
            this.currentStepEl.textContent = index + 1;
        }
        // this.prevBtn.style.display = (index === 0) ? 'none' : 'inline-block';
        if(this.nextBtn) {
            this.nextBtn.style.display = (index === this.steps.length - 1) ? 'none' : 'inline-block';
        }
        this.submitBtn.style.display = (index === this.steps.length - 1) ? 'inline-block' : 'none';
        this.submitWrapper.style.display = (index === this.steps.length - 1) ? 'inline-block' : 'none';

        // this.updateNextButtonState();
        // if (index === this.steps.length - 1) {
        //     this.generateArithmeticProblem();
        // }
    }

    validateStep(index) {
        const inputs = this.steps[index].querySelectorAll('.form-option-interest > .active');
        let isValid = inputs.length > 0;

        if (index === this.steps.length - 1) {
            const answerInput = this.steps[index].querySelector('.form-option-interest');
            if(answerInput) {
                if (answerInput.value.trim() !== '' && parseInt(answerInput.value.trim()) === this.currentAnswer) {
                    isValid = true;
                } else {
                    isValid = false;
                    answerInput.classList.add('invalid');
                }
            }
        }

        return isValid;
    }

    updateNextButtonState(e) {
        if(e) {
            const wrapper = e.target.closest('.wpcf7-form-control-wrap');
            wrapper.classList.toggle('active');
            const checkbox = wrapper.querySelector('input[type="checkbox"]');
            if (checkbox) {
                checkbox.checked = !checkbox.checked; // Переключение чекбокса
            }
            const isStepValid = this.validateStep(this.currentStep);
            if (isStepValid) {
                this.nextBtn.classList.add('active-btn');
            } else {
                this.nextBtn.classList.remove('active-btn');
            }
        }
        // this.submitBtn.disabled = !isStepValid;
    }

    checkAutoFill() {
        const inputs = this.steps[this.currentStep].querySelectorAll(this.requiredFields);
        if (inputs.length) {
            inputs.forEach(input => {
                if (input.value.trim() !== '' && input.checkValidity()) {
                    input.dispatchEvent(new Event('input'));
                }
            });

            this.updateNextButtonState();
        }
    }

    addEventListeners() {
        if(this.nextBtn) {
            this.nextBtn.addEventListener('click', () => {
                if (this.validateStep(this.currentStep)) {
                    this.currentStep++;
                    this.showStep(this.currentStep);
                    this.nextBtn.classList.remove('active-btn');
                }
            });
        }

        // this.steps.forEach((step, index) => {
        //     const inputs = step.querySelectorAll(this.requiredField);
        //     inputs.forEach(input => {
        //         input.addEventListener('input', () => {
        //             this.updateNextButtonState()
        //         });
        //     });
        // });

        window.addEventListener('load', () => {
            this.checkAutoFill();
        });

        this.steps.forEach(step => {
            const inputs = step.querySelectorAll('.form-option-interest');
            inputs.forEach(input => {
                input.addEventListener('click', (e) => this.updateNextButtonState(e));
            });
        });

        this.selectInterestForm.addEventListener('click', (e) => {
            this.changeForm(e);
            if(this.currentStep !== this.steps.length - 1) {
                this.submitWrapper.style.display = 'none';
                this.submitBtn.style.display = 'none';
            }
        });

        this.selectContactForm.addEventListener('click', (e) => {
            this.changeForm(e);
            this.submitWrapper.style.display = 'inline-block';
            this.submitBtn.style.display = 'inline-block';
        });

        const inputs = this.form.querySelectorAll('.wpcf7-validates-as-required');
        const submitButton = this.form.querySelector('.wpcf7-submit'); // Убедитесь, что у кнопки есть ID

        if (inputs.length) {
            inputs.forEach(input => {
                input.addEventListener('input', () => {
                    checkFormValidity();
                });
                input.addEventListener('click', () => {
                    checkFormValidity();
                });
                input.addEventListener('blur', () => {
                    checkFormValidity();
                });
            });

            const phoneOption = this.form.querySelector('input[type="radio"][value="Telefon"]');
            const emailOption = this.form.querySelector('input[type="radio"][value="E-Mail"]');
            const phoneOptionsDiv = this.form.querySelector("#phone-options");
            function togglePhoneOptions() {
                if(phoneOptionsDiv) {
                    phoneOptionsDiv.style.display = phoneOption.checked ? "flex" : "none";
                }
            }

            if (phoneOption && emailOption) {
                phoneOption.addEventListener("change", togglePhoneOptions);
                emailOption.addEventListener("change", togglePhoneOptions);
            }

            togglePhoneOptions(); // Проверка при загрузке страницы
        }

        function checkFormValidity() {
            const allFilled = Array.from(inputs).every(input =>
                (input.value ? input.value.trim() !== '' : true) && input.checkValidity()
            );
            if(allFilled) {
                submitButton.style.pointerEvents = 'auto';
                submitButton.style.opacity = 1;
            } else {
                submitButton.style.opacity = .55;
                submitButton.style.pointerEvents = 'none';
            }
        }

        // this.submitBtn.addEventListener('click')
    }

    generateArithmeticProblem() {
        const firstNum = Math.floor(Math.random() * 10);
        const secondNum = Math.floor(Math.random() * 10);
        this.currentAnswer = firstNum + secondNum;

        const questionElement = this.steps[this.steps.length - 1].querySelector('.question');
        questionElement.innerHTML = `${firstNum} + ${secondNum} =`;
    }

    afterSending() {
        document.addEventListener('wpcf7mailsent', (event) => {
            let success = this.form.querySelectorAll('.col-6');
            if (success.length > 0) {
                setTimeout(() => {
                    success.forEach((elem) => {
                        elem.outerHTML = "<div class='col-6 success-message'><p>Request sent successfully!</p></div>";
                    });
                    this.form.querySelectorAll('.steps').forEach((steps) => {
                        steps.classList.toggle('hidden');
                    })
                }, 1000)
            }
        }, false);
    }

    changeForm(e) {
        let activeForm = document.querySelector('.form-render > .d-block');
        if (activeForm && e.target.id.replace('change-', '') !== activeForm.id) {
            this.selectInterestForm.classList.toggle('active');
            this.selectContactForm.classList.toggle('active');
            document.querySelector('.form-interest').classList.toggle('d-block');
            document.querySelector('.form-contact').classList.toggle('d-block');
        }
    }
}
